import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faHeart,
  faHome,
  faMapMarker,
  faShoppingCart,
  faStar,
  faUser,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import {
  BrandProductReviewList,
  BrandProducts,
  getBrandProductReviewsByBrand,
  getProductsByBrand
} from 'api/categories/_requests';
import EcomBrandDetailAddressInfo from 'components/forms/EcomBrandDetailAddressInfo';
import EcomBrandDetailInfo from 'components/forms/EcomBrandDetailInfo';
import EcomBrandDetailReviewsTable from 'components/tables/EcomBrandDetailReviewsTable';
import EcomBrandListProductTable from 'components/tables/EcomBrandListProductTable';
import EcomVendorBrandProductReviewsTable from 'components/tables/EcomVendorBrandProductReviewsTable';
import EcomVendorDetialReviewsTable from 'components/tables/EcomVendorDetialReviewsTable';
import { PF } from 'helpers/utils';
import { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';

interface TabLink {
  id: string;
  label: string;
  number?: number;
  icon: IconProp;
  content: (brandId?: string) => JSX.Element;
  role?: 'customer' | 'vendor' | 'both';
}

const BrandDetailsTabs = ({ brandSlug }: { brandSlug?: string }) => {
  const [brandProducts, setBrandProducts] = useState<BrandProducts[]>([]);

  const { data: brandproductReviews } = useQuery<BrandProductReviewList>({
    queryKey: ['brandproductReview-by-brand', brandSlug],
    queryFn: () => getBrandProductReviewsByBrand(brandSlug!),
    enabled: !!brandSlug
  });

  const fetchProductsData = async () => {
    try {
      const response = await getProductsByBrand(brandSlug!);
      const temp = response.map((item: BrandProducts) => ({
        ...item,
        thumbnail:
          PF + (item.thumbnail !== undefined ? item.thumbnail : 'goods')
      }));

      setBrandProducts(temp);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    }
  };
  useEffect(() => {
    fetchProductsData();
  }, []);

  const tabLinks: TabLink[] = [
    {
      id: 'products',
      label: 'Products',
      icon: faShoppingCart,
      number: brandProducts?.length ?? 0,
      content: brandId => (
        <EcomBrandListProductTable productsData={brandProducts ?? []} />
      ),
      role: 'both'
    },
    {
      id: 'brandreview',
      label: 'Brand Reviews',
      number: brandproductReviews?.brandReviews?.length ?? 0,
      icon: faStar,
      content: brandId => (
        <EcomBrandDetailReviewsTable
          brandReviews={brandproductReviews?.brandReviews ?? []}
        />
      ),
      role: 'both'
    },
    {
      id: 'review',
      label: 'Product Reviews',
      number: brandproductReviews?.productReviews?.length ?? 0,
      icon: faStar,
      content: brandId => (
        <EcomVendorBrandProductReviewsTable
          vendorbrandproductReviews={brandproductReviews?.productReviews ?? []}
        />
      ),
      role: 'both'
    },
    {
      id: 'personal-info',
      label: 'Personal info',
      icon: faUser,
      content: brandId => <EcomBrandDetailInfo brandId={brandId} />,
      role: 'both'
    },
    {
      id: 'address',
      label: 'Address',
      icon: faMapMarker,
      content: brandId => <EcomBrandDetailAddressInfo brandId={brandId} />,
      role: 'both'
    }
  ];

  return (
    <Tab.Container defaultActiveKey="products">
      <Nav className="mb-3 pb-1 gap-3 nav-underline flex-nowrap scrollbar">
        {tabLinks.map(item => (
          <Nav.Item key={item.id}>
            <Nav.Link eventKey={item.id} className="text-nowrap">
              <FontAwesomeIcon icon={item.icon} className="me-2" />
              {item.label}{' '}
              {item.number && (
                <span className="text-body-tertiary fw-normal">
                  ({item.number})
                </span>
              )}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Tab.Content>
        {tabLinks.map(item => (
          <Tab.Pane
            key={item.id}
            eventKey={item.id}
            // title={
            //   <>
            //     <FontAwesomeIcon icon={item.icon} className="me-2" />
            //     {item.label}{' '}
            //     {item.number && (
            //       <span className="text-body-tertiary fw-normal">({item.number})</span>
            //     )}
            //   </>
            // }
          >
            {item?.content(brandSlug)}
          </Tab.Pane>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

export default BrandDetailsTabs;
